<div *ngFor="let shielding of shieldings" class="py-1">
  <cl-note
    *ngIf="shielding.type == resourceType.ShieldingNote; else shieldingCheckbox"
    [text]="shielding.keText"
    [editor]="editor"
  ></cl-note>
  <ng-template #shieldingCheckbox>
    <cl-checkbox
      [number]="shielding.index.toString()"
      [question]="shielding.keText"
      [checked]="shielding.checked"
      [disabled]="shieldingCheckboxDisabled()"
      [color]="color"
      [roleCodes]="roleCodes"
      [user]="shielding.user"
      [date]="shielding.date"
      [checkboxVisible]="checkboxVisible"
      (answered)="checkboxChanged(shielding, $event)"
    ></cl-checkbox>
  </ng-template>
</div>
